import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../components/Modal/Modal";
import { Container, StyledButton, Wrapper } from "../../components/styled/styled-components";
import { useOrderUploaderContext } from "./context/OrderUploaderContext";

export type OrderUploadResult =
  | "progressBar"
  | "progressBarLevel"
  | "addingToCart"
  | "goToCart"
  | "clearCart";

const ModalSwitcher = () => {
  const {
    modalToShow,
    setModalToShow,
    handleClearCart: clearCart,
    isLoading,
    progressBarLevel,
  } = useOrderUploaderContext();
  const navigate = useNavigate();
  return (
    <>
      {modalToShow === "progressBar" && (
        <Modal>
          <div className="modalContent">
            <p>Please wait while we import your order</p>

            <div className="loadingSpinnerWrapper">
              <LoadingSpinner />
            </div>
          </div>
        </Modal>
      )}

      {modalToShow === "progressBarLevel" && (
        <Modal>
          <div className="modalContent">
            <p>Please wait while we import your order</p>
            <p>
              Loaded {progressBarLevel.level} out of {progressBarLevel.totalItems} items
            </p>
            <div className="loadingSpinnerWrapper">
              <LoadingSpinner />
            </div>
            <div className="progress">
              <div
                className="progress-bar progress-bar-striped bg-info"
                role="progressbar"
                style={{
                  width: `${
                    progressBarLevel.totalItems > 0
                      ? (progressBarLevel.level / progressBarLevel.totalItems) * 100
                      : 0
                  }%`,
                }}
                aria-valuenow={progressBarLevel.level}
                aria-valuemin={0}
                aria-valuemax={progressBarLevel.totalItems}
              />
            </div>
          </div>
        </Modal>
      )}

      {modalToShow === "addingToCart" && (
        <Modal>
          <div className="modalContent">
            <p>Please wait while we add your items to your cart</p>
            <div className="loadingSpinnerWrapper">
              <LoadingSpinner />
            </div>
          </div>
        </Modal>
      )}

      {modalToShow === "goToCart" && (
        <Modal>
          <div className="modalContent">
            <p>Items added to cart.</p>
            <Wrapper>
              <StyledButton onClick={() => navigate("/store/cart")}>View Cart</StyledButton>
            </Wrapper>
          </div>
        </Modal>
      )}

      {modalToShow === "clearCart" && (
        <Modal>
          <div className="modalContent">
            {isLoading ? (
              <>
                <p>Removing items from cart</p>
                <Wrapper>
                  <LoadingSpinner />
                </Wrapper>
              </>
            ) : (
              <>
                <p>You have items in your current cart.</p>
                <p>Please clear your current cart to add these ones.</p>
                <Container>
                  <StyledButton onClick={() => clearCart()} style={{ margin: "1em 0" }} warning>
                    Clear cart
                  </StyledButton>
                  <StyledButton onClick={() => setModalToShow(null)}>Cancel</StyledButton>
                </Container>
              </>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default ModalSwitcher;
